import { api } from "@services/baseURL";

export const SaveProcesso = async (data) => {
  try {
    const response = await api.post('Processo', data);
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar processo:', error);
    throw error;
  }
};

export const UpdateProcesso = async (id, data) => {
  try {
    const response = await api.patch(`Processo/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar processo:', error.response?.data || error.message);
    throw error;
  }
};

export const DeleteProcesso = async (id) => {
  try {
    await api.delete(`Processo/${id}`);
    return true;
  } catch (error) {
    console.error('Erro ao deletar processo:', error);
    throw error;
  }
};

export const GetAllProcessos = async (pageSize, rowsPerPage, filters = {}) => {
  try {
    const response = await api.get('Processo', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar todos processos:', error);
    throw error;
  }
};

export const GetByIdProcesso = async (id) => {
  try {
    const response = await api.get(`Processo/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar processo:', error);
    throw error;
  }
};

export default {
  SaveProcesso,
  UpdateProcesso,
  DeleteProcesso,
  GetByIdProcesso,
  GetAllProcessos
};